import "babel-polyfill"
import Vue from 'vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import App from './App'
import router from './router'
import store from './store/store'
import './assets/css/public.css';

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-contrib-hls";
Vue.prototype.$video = videojs;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
router.beforeEach((to, from, next) => {
  // console.log('路由即将改变：', from.path, '->', to.path);

  if (from.path == '/ksbm') {
    // console.log(111111111)
    window.localStorage.removeItem('active')
  }
  next();
});

// router.afterEach((to, from) => {
//   console.log('路由已改变：', from.path, '->', to.path);
// });


// WEBPACK FOOTER //
// ./src/main.js